import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { animations } from "helpers/animations";
import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useScrollTop } from "hooks/useScrollTop";
import { blue } from "@mui/material/colors";

export const GlobalBox = ({
  children,
  title = "",
  icon = null,
  controls = null,
  style = {},
  titleSx = {},
  styleBody={},
  head = false 
}) => {
  
  useScrollTop();
  return (
    <Card
      className={animations.fadeIn}
      style={{
        transition: "all .3s ease-in-out",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
        ...style,
      }}
    >
      <Typography
        variant="subtitle1"
        style={{
          width: '100%',
          position: "absolute",
          padding: 7,
          paddingLeft: head ? 7 : 90,
          background: head ? blue[800] : 'none',
          color: head ? 'white' : 'none',
          ...titleSx
        }}
      >
        {title}
      </Typography>
      <CardHeader color="info" icon>
        {icon ? <CardIcon color="info">{icon}</CardIcon> : null}
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 4,
            padding: 4,
            marginTop: 16,
            float: "right",
          }}
        >
          {controls}
        </Box>
      </CardHeader>
      <CardBody style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        marginTop: 16,
        ...styleBody
        }}>{children}</CardBody>
    </Card>
  );
};
